import styled from 'styled-components';

export const Container = styled.div`
  width: 42px;
  height: 34px;
  min-width: 42px;
  min-height: 34px;
  position: relative;

  display: flex;
  align-items: end;
  justify-content: end;
`;

export const Tool = styled.img`
  width: 18px;
  height: 18px;
  position: absolute;
  left: 0px;
  top: 0px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
`;
